import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('loaderContainer'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('loading '))
    }, null, 2 /* CLASS */)
  ], 2 /* CLASS */))
}